import resolve from '../../../../../modules/api/resolve';
import { apiGet, apiStore } from '../../../../../modules/apiHelper';
import {
  invalideDate, isStaleData, now, objectIsValid,
} from '../../../../../modules/dataHelper';

export default {
  async loadMyActiveCompanyProgram(context) {
    const loggedInProgramId = context.rootGetters.userCompanyProgramId;

    if (!loggedInProgramId) {
      context.commit('setActiveProgram', {});
      return;
    }

    const program = await context.dispatch('getProgram', [loggedInProgramId, false]);

    context.commit('setActiveProgram', program || {});
  },

  async getProgramTypes(context, refresh = false) {
    const CACHE_KEY = 'programTypes';

    const programTypes = await apiStore.getItem(CACHE_KEY) || [invalideDate, {}];

    if (!refresh && !isStaleData(programTypes[0]) && objectIsValid(programTypes[1])) return programTypes[1];

    if (refresh) {
      apiStore.removeItem(CACHE_KEY);
    }

    const response = await resolve(apiGet('prog_types', 79)).then(async (data) => {
      if (!data) return false;

      return data.prog_types;
    });

    if (!response) return false;

    apiStore.setItem(CACHE_KEY, [now(), response]);

    return response;
  },
};
